import { Directive, Input, ElementRef, HostListener } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appMaxDecimals]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MaxDecimalsDirective,
      multi: true,
    },
  ],
})
export class MaxDecimalsDirective implements Validator{

  @Input() appMaxDecimals = 2;

  constructor(private el: ElementRef<HTMLInputElement>) { }

  validate(control: AbstractControl): ValidationErrors | null {

    const value = this.el.nativeElement.value;

    if (!value) {
      return null;
    }

    const normalized = value.replace(',', '.');

    if (/e/i.test(normalized)) {
      return { scientificNotation: true };
    }

    const parts = normalized.split('.');

    if (parts.length < 2) {
      return null;
    }

    const decimalPart = parts[1].replace(/0+$/, '');
    const decimals = decimalPart.length;

    if (decimals > this.appMaxDecimals) {
      return {
        maxDecimals: {
          max: this.appMaxDecimals,
          translationKey: 
            this.appMaxDecimals === 0
              ? 'Validators.noDecimalsAllowed'
              : this.appMaxDecimals === 1 
              ? 'Validators.singleDecimalAllowed'
              : 'Validators.multipleDecimalsAllowed'
        },
      };
    }

    return null;
  }

}
